// import axios from "axios";
// import baseUrl from "./config";


// const newRequest = axios.create({
//   baseURL: baseUrl,
// });

// export default newRequest;
// export default newRequest;


// import axios from "axios";
// import Cookies from "js-cookie";
// import baseUrl from "./config";

// const token = Cookies.get("accessToken");
// const token=sessionStorage.getItem('accessToken')
// const newRequest = axios.create({
//   baseURL: baseUrl,
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// });

// export default newRequest;


import axios from 'axios'
import baseUrl from './config'

const newRequest = axios.create({
  baseURL: baseUrl
})

// Dynamically add token to each request
newRequest.interceptors.request.use(config => {
  const token = sessionStorage.getItem('accessToken')
  //   console.log(token, 'token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default newRequest
